module.exports = __webpack_public_path__ + "static/media/Leo.b5279040.jpg";